export default "__VITE_ASSET__d8631a48__"